import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import Messages from '../../../../shared/UI/Messages/Messages';

import { REDIRECT_TO_URL } from '../../../../shared/utility';
import { Companyid } from '../../../../shared/Config';
import FooterButton from '../../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../../store/actions/index';

class AddCategory extends Component {
    state = {
        type: 'add',
        Id: null,
        CategoryCode: '',
        CategoryName: '',
        PreferredVendor: [],
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        const type = this.props.match.params.type;

        this.setState({ type });

        // Vendor options for the Preferred Vendor multiselect
        this.props.getMasterKeywordList("Vendor");

        if (type !== "add") {
            this.props.getMasterTableList(
                `res/GetInvingredientCategorybyid?ingredientCategoryId=${id}`,
                this.state.CompanyId
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.tableLists !== prevProps.tableLists) {
            const Category = Array.isArray(this.props.tableLists)
                ? this.props.tableLists[0]
                : this.props.tableLists;

            if (!Category) return;

            
            // API returns approved vendors as a comma-separated string of ids.
            // Normalize each id to match the exact casing used in the Vendor dropdown options
            // so that the MultiSelect can correctly select and display the vendor names.
            let vendors = [];
            const approvedVendor = Category.approvedvendor || Category.preferredVendor;
            if (approvedVendor) {
                const rawIds = Array.isArray(approvedVendor)
                    ? approvedVendor.map(String)
                    : String(approvedVendor).split(',');

                const vendorOptions = this.props.Vendor || [];
                vendors = rawIds
                    .map(id => id.trim())
                    .filter(id => id !== '')
                    .map(id => {
                        const match = vendorOptions.find(
                            v => String(v.value).toLowerCase() === id.toLowerCase()
                        );
                        return match ? String(match.value) : id;
                    });
            }

            this.setState({
                Id: Category.ingredientCategoryId,
                CompanyId: Category.companyId || Category.companyid || this.state.CompanyId,
                CategoryCode: Category.categoryCode || "",
                CategoryName: Category.categoryname || Category.categoryName || "",
                PreferredVendor: vendors
            });
        }
    }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            touch: true
        });
    }

    onMultiSelectChange = (e) => {
        this.setState({
            [e.target.name]: e.value,
            touch: true
        });
    }

    add = () => {
        if (this.state.CategoryCode === null || this.state.CategoryCode.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Category Code is required' });
            return;
        } else if (this.state.CategoryName === null || this.state.CategoryName.trim() === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Category Name is required' });
            return;
        } else if (!this.state.PreferredVendor || this.state.PreferredVendor.length === 0) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Preferred Vendor is required' });
            return;
        }
            
        const data = {
            categoryname: this.state.CategoryName,
            companyId: this.state.CompanyId,
            categoryCode: this.state.CategoryCode,
            approvedvendor: this.state.PreferredVendor.join(',')
        }

        if (this.state.type === 'edit') {
            data.ingredientCategoryId = this.state.Id;
        }

        this.props.processDynamicData(
            'invingredientCategory',
            this.state.type,
            data,
            `res/GetinvingredientCategoryList?companyId=${this.state.CompanyId || Companyid}`
        );
    }

    resetData = () => {
        this.setState({
            Id: null,
            CategoryCode: '',
            CategoryName: '',
            PreferredVendor: [],
            touch: false
        });
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/category/', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let isEnabled = (this.state.touch === true);

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Add Category</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-6 p-offset-3">

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Category Code <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="CategoryCode" placeholder="Category Code" value={this.state.CategoryCode} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Category Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="p-col-12" name="CategoryName" placeholder="Category Name" value={this.state.CategoryName} onChange={this.change} disabled={this.state.type === 'view'} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="acSimple">Preferred Vendor <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <MultiSelect className="p-col-12" placeholder="Select Preferred Vendor" options={this.props.Vendor} value={this.state.PreferredVendor} name="PreferredVendor" onChange={this.onMultiSelectChange} filter={true} disabled={this.state.type === 'view'} />
                                </div>

                            </div>
                            <div className="p-col-12 p-lg-12">
                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === "view"}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to="/category/"
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Vendor: (state.keyword.Vendor !== undefined) ? state.keyword.Vendor : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCategory);
